import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import paginationFactory, {
    PaginationProvider,
    PaginationTotalStandalone,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import Loader from "../../../Global/loader";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { AiFillCaretUp, AiFillCaretDown } from "react-icons/ai";
import { GetBarrierList } from "../../../Services/barrier";
import Edit from "./Edit";
import { useHistory } from "react-router-dom";

const BariersList = (data) => {
    const history = useHistory();
    const { barrierList } = useSelector((state) => state.barrierSlice);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        async function getData() {
            let url = history.location.pathname;
            let urldivided = url.split("/");
            await GetBarrierList(dispatch, { id: urldivided[2] });
            await setLoading(false);
        }
        getData();
    }, [dispatch, history.location.pathname]);

    const columns = [
        {
            dataField: "name",
            text: "NAZIV",
            style: { wordWrap: "break-word" },
            sort: true,
            sortCaret: (order, column) => {
                if (!order)
                    return (
                        <span>
                            &nbsp;&nbsp;
                            <AiFillCaretUp color={"white"} />
                            <AiFillCaretDown color={"white"} />
                        </span>
                    );
                else if (order === "asc")
                    return (
                        <span>
                            &nbsp;&nbsp; <AiFillCaretDown color={"white"} />
                        </span>
                    );
                else if (order === "desc")
                    return (
                        <span>
                            &nbsp;&nbsp;
                            <AiFillCaretUp color={"white"} />
                        </span>
                    );
                return null;
            },
        },
        {
            dataField: "parklioId",
            text: "UUID",
            style: { wordWrap: "break-word" },
            sort: true,
            sortCaret: (order, column) => {
                if (!order)
                    return (
                        <span>
                            &nbsp;&nbsp;
                            <AiFillCaretUp color={"white"} />
                            <AiFillCaretDown color={"white"} />
                        </span>
                    );
                else if (order === "asc")
                    return (
                        <span>
                            &nbsp;&nbsp; <AiFillCaretDown color={"white"} />
                        </span>
                    );
                else if (order === "desc")
                    return (
                        <span>
                            &nbsp;&nbsp;
                            <AiFillCaretUp color={"white"} />
                        </span>
                    );
                return null;
            },
        },
        {
            dataField: "note",
            text: "NAPOMENA",
            style: { wordWrap: "break-word" },
            sort: true,
            sortCaret: (order, column) => {
                if (!order)
                    return (
                        <span>
                            &nbsp;&nbsp;
                            <AiFillCaretUp color={"white"} />
                            <AiFillCaretDown color={"white"} />
                        </span>
                    );
                else if (order === "asc")
                    return (
                        <span>
                            &nbsp;&nbsp; <AiFillCaretDown color={"white"} />
                        </span>
                    );
                else if (order === "desc")
                    return (
                        <span>
                            &nbsp;&nbsp;
                            <AiFillCaretUp color={"white"} />
                        </span>
                    );

                return null;
            },
        },
        {
            dataField: "createdAt",
            text: "KREIRAN",
            style: { wordWrap: "break-word" },
            formatter: (cellContent, row) => {
                return (
                    <span>
                        {moment(cellContent).format("DD.MM.YYYY HH:mm:ss")}
                    </span>
                );
            },
        },
        {
            dataField: "sakriveno",
            text: "",
            isDummyField: true,
            style: { wordWrap: "break-word" },
            headerStyle: (colum, colIndex) => {
                return { textAlign: "center" };
            },

            formatter: (cellContent, row) => {
                return (
                    <div key={row.id} style={{ wordWrap: "break-word" }}>
                        <Edit data={row} />
                    </div>
                );
            },
        },
    ];

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            {from} - {to} of {size} Operatera
        </span>
    );

    const pageButtonRenderer = ({
        page,
        active,
        disabled,
        title,
        onPageChange,
    }) => {
        const handleClick = (e) => {
            e.preventDefault();
            onPageChange(page);
        };
        return (
            <li
                className={
                    active
                        ? "active page-item"
                        : disabled
                        ? "disabled page-item"
                        : "page-item"
                }
                style={{ color: "white" }}
                key={page}
            >
                <button className="page-link" onClick={handleClick}>
                    {page}
                </button>
            </li>
        );
    };

    const sizePerPageOptionRenderer = ({ text, page, onSizePerPageChange }) => (
        <li key={text} role="presentation" className="dropdown-item">
            <div
                tabIndex="-1"
                role="menuitem"
                data-page={page}
                onMouseDown={(e) => {
                    e.preventDefault();
                    onSizePerPageChange(page);
                }}
                style={{ color: "white" }}
            >
                {text}
            </div>
        </li>
    );

    const options = {
        custom: true,
        totalSize: barrierList.length,
        sizePerPageOptionRenderer,
        paginationTotalRenderer: customTotal,
        prePageText: "<",
        nextPageText: ">",
        withFirstAndLast: false,
        alwaysShowAllBtns: true,
        sizePerPage: 10,
        pageButtonRenderer,
        page: 1,
    };

    return (
        <div className="table-design">
            {loading ? (
                <div className="operators_container">
                    <Row
                        style={{ justifyContent: "center", paddingTop: "10%" }}
                    >
                        <Loader />
                    </Row>
                </div>
            ) : barrierList.length < 1 ? (
                <Row style={{ paddingTop: "30px", textAlign: "center" }}>
                    <h1>Lista je prazna</h1>
                </Row>
            ) : (
                <PaginationProvider pagination={paginationFactory(options)}>
                    {({ paginationProps, paginationTableProps }) => (
                        <div>
                            <BootstrapTable
                                keyField="id"
                                data={barrierList}
                                columns={columns}
                                {...paginationTableProps}
                                sort={{ dataField: "name", order: "asc" }}
                                noDataIndication="Lista je prazna"
                            />

                            <Row>
                                <Col sm={2} md={6} xl={6} xxl={6}></Col>

                                <Col
                                    sm={10}
                                    md={6}
                                    xl={6}
                                    xxl={6}
                                    className="pagination-right"
                                >
                                    <PaginationListStandalone
                                        {...paginationProps}
                                    />
                                    <span className="react-bootstrap-table-pagination-total">
                                        Redova po stranici:{" "}
                                    </span>
                                    <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                    />
                                    <PaginationTotalStandalone
                                        {...paginationProps}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                </PaginationProvider>
            )}
        </div>
    );
};

export default BariersList;
